// UUID v4 sin dependencias. `crypto.randomUUID` solo existe en contextos seguros
// (HTTPS o localhost): el dev server corre en http://localhost.com, así que ahí se
// arma con `crypto.getRandomValues`, que está disponible en cualquier contexto.
const uuid = () => {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // versión 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variante RFC 4122
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

export default uuid;
